import client from '../client';
import { exportFile } from '../requestDownloadFile';

export default {
  exportCommissionBrandReports: data => {
    return exportFile('seller/commission/reports/brand/export', data.qs, data.fileName);
  },
  exportCommissionPublisherReports: data => {
    return exportFile('seller/commission/reports/publisher/export', data.qs, data.fileName);
  },
  exportCommissionProductReports: data => {
    return exportFile('seller/commission/reports/product/export', data.qs, data.fileName);
  },
  exportCommissionProductDailyReports: data => {
    return exportFile('seller/commission/reports/product/daily/export', data.qs, data.fileName);
  },
  exportCommissionPerformanceReports: data => {
    return exportFile('seller/commission/reports/performance/export', data.qs, data.fileName);
  },


  getSellerCommissionReportsAgg: data => {
    return client.get(`seller/commission/reports/agg`, { params: data }).then(res => res.data);
  },


  getSellerCommissionReportsBrand: data => {
    return client.get(`seller/commission/reports/brand`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsBrandDailyMetric: data => {
    return client.get(`seller/commission/reports/brand/daily-metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsBrandMetric: data => {
    return client.get(`seller/commission/reports/brand/metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPerformance: data => {
    return client.get(`seller/commission/reports/performance`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPerformanceDailyMetric: data => {
    return client.get(`seller/commission/reports/performance/daily-metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsProduct: data => {
    return client.get(`seller/commission/reports/product`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsProductDailyMetric: data => {
    return client.get(`seller/commission/reports/product/daily-metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsProductMetric: data => {
    return client.get(`seller/commission/reports/product/metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPublisher: data => {
    return client.get(`seller/commission/reports/publisher`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPublisherDailyMetric: data => {
    return client.get(`seller/commission/reports/publisher/daily-metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPublisherMetric: data => {
    return client.get(`seller/commission/reports/publisher/metric`, { params: data }).then(res => res.data);
  },
  getSellerBrandSearch: data => {
    return client.get(`seller/brands/search`, { params: data }).then(res => res.data);
  },
  getSellerProductSearch: data => {
    return client.get(`seller/product/searchAsin`, { params: data }).then(res => res.data);
  },
  // 新增接口 seller performance Associate
  //tag
  getSellerCommissionReportsAggAssociate: data => {
    return client.get(`seller/associate/commission/reports/agg`, { params: data }).then(res => res.data);
  },
  //table
  getSellerCommissionReportsPerformanceAssociate: data => {
    return client.get(`seller/associate/commission/reports/performance`, { params: data }).then(res => res.data);
  },
  //echart
  getSellerCommissionReportsPerformanceDailyMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/performance/daily-metric`, { params: data }).then(res => res.data);
  },
  //导出
  exportCommissionPerformanceReportsAssociate: data => {
    return exportFile('seller/associate/commission/reports/performance/export', data.qs, data.fileName);
  },
  //新增接口 seller product Associate
  //table
  getSellerCommissionReportsProductAssociate: data => {
    return client.get(`seller/associate/commission/reports/product`, { params: data }).then(res => res.data);
  },
  //  //echart daily
  getSellerCommissionReportsProductMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/product/metric`, { params: data }).then(res => res.data);
  },
  //echart daily-metric
  getSellerCommissionReportsProductDailyMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/product/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionProductReportsAssociate: data => {
    return exportFile('seller/associate/commission/reports/product/export', data.qs, data.fileName);
  },
  exportCommissionProductReportsAssociateByDate: data => {
    return exportFile('seller/associate/commission/reports/product/daily/export', data.qs, data.fileName);
  },
  //新增接口 seller brand Associate
  //table
  getSellerCommissionReportsBrandAssociate: data => {
    return client.get(`seller/associate/commission/reports/brand`, { params: data }).then(res => res.data);
  },
  //echart daily-metric
  getSellerCommissionReportsBrandDailyMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/brand/daily-metric`, { params: data }).then(res => res.data);
  },
  //echart daily
  getSellerCommissionReportsBrandMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/brand/metric`, { params: data }).then(res => res.data);
  },
  //导出
  exportCommissionBrandReportsAssociate: data => {
    return exportFile('seller/associate/commission/reports/brand/export', data.qs, data.fileName);
  },

  //新增接口 seller publisher Associate 
  // agg
  getPublisherCommissionReportsAggAssociate: data => {
    return client.get(`seller/associate/commission/reports/agg`, { params: data }).then(res => res.data);
  },
  //table
  getSellerCommissionReportsPublisherAssociate: data => {
    return client.get(`seller/associate/commission/reports/publisher`, { params: data }).then(res => res.data);
  },
  //echart daily-metric
  getSellerCommissionReportsPublisherDailyMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/publisher/daily-metric`, { params: data }).then(res => res.data);
  },
  //echart daily
  getSellerCommissionReportsPublisherMetricAssociate: data => {
    return client.get(`seller/associate/commission/reports/publisher/metric`, { params: data }).then(res => res.data);
  },
  //导出
  exportCommissionPublisherReportsBrandAssociate: data => {
    return exportFile('seller/associate/commission/reports/publisher/export', data.qs, data.fileName);
  },

  // seller performance Creator Connections
  getSellerCommissionReportsAggCc: data => {
    return client.get(`seller/cc/bonus/reports/agg`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPerformanceCc: data => {
    return client.get(`seller/cc/bonus/reports/performance`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPerformanceDailyMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/performance/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionPerformanceReportsCc: data => {
    return exportFile('seller/cc/bonus/reports/performance/export', data.qs, data.fileName);
  },

  // seller product Creator Connections
  getSellerCommissionReportsProductCc: data => {
    return client.get(`seller/cc/bonus/reports/product`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsProductMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/product/metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsProductDailyMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/product/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionProductReportsCc: data => {
    return exportFile('seller/cc/bonus/reports/product/export', data.qs, data.fileName);
  },
  exportCommissionProductReportsCcByDate: data => {
    return exportFile('seller/cc/bonus/reports/product/daily/export', data.qs, data.fileName);
  },

  // seller brand Creator Connections
  getSellerCommissionReportsBrandCc: data => {
    return client.get(`seller/cc/bonus/reports/brand`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsBrandMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/brand/metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsBrandDailyMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/brand/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionBrandReportsCc: data => {
    return exportFile('seller/cc/bonus/reports/brand/export', data.qs, data.fileName);
  },

  // seller publisher Creator Connections
  getSellerCommissionReportsPublisherCc: data => {
    return client.get(`seller/cc/bonus/reports/publisher`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPublisherMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/publisher/metric`, { params: data }).then(res => res.data);
  },
  getSellerCommissionReportsPublisherDailyMetricCc: data => {
    return client.get(`seller/cc/bonus/reports/publisher/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionPublisherReportsCc: data => {
    return exportFile('seller/cc/bonus/reports/publisher/export', data.qs, data.fileName);
  },
}
